document.addEventListener('teeinblue-event-component-injected', function() {
  document.querySelectorAll('[id*="judge_me_reviews_preview_badge"]').forEach(block => {
    const productPriceEl = document.querySelector('.tee-product-price');
    if (!productPriceEl) return;

    productPriceEl.appendChild(block);

    const observer = new MutationObserver(() => {
        productPriceEl.appendChild(block);
    });

    observer.observe(block, {
        childList: true,
        subtree: true
    });
  });
});


/* ── Teeinblue × AMP Slide Cart — personalised line-item thumbnails ────
 * Ported from flagvibe.com. Slide Cart renders <img src="{line.image}"> and
 * never reads line-item properties; React re-uses those <img> nodes because
 * the line is keyed variant_id+index. We read _customization_image out of the
 * cart Slide Cart already holds in memory, inside the MutationObserver
 * callback — same microtask the line is written to the DOM, so before paint.
 *
 * Requires theme.liquid: teeinblue.cartIgnoreSelectors = ['#slidecarthq'],
 * otherwise Teeinblue's own cart-thumbnail component owns this node instead.
 * This must be the only script touching the Slide Cart thumbnails.
 */
(function () {
  'use strict';

  // Floor on how long .is-loading stays up, measured from when it first went up
  // for a given design — not per attempt. A design already in the browser cache
  // is swapped in with no loading state at all.
  var MIN_LOADING_MS = 700;
  var MAX_LOADING_MS = 10000;  // fail-safe: give up on a design after this
  var RETRIES        = 3;      // Teeinblue's render is often not on the CDN yet
  var RETRY_MS       = 1500;
  var BLANK = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  var ready = {}, failed = {}, loading = {}, tries = {}, cool = {}, since = {};
  var stock = {};   // variant id -> Slide Cart's own product photo
  var root  = null;

  function isStock(src) {
    return !!src && src.indexOf('teeinblue') === -1 && src.indexOf('data:') !== 0;
  }

  // Design URL, null if the line is genuinely not personalised, or undefined if
  // Slide Cart's in-memory cart doesn't describe this line right now. The
  // undefined case matters: treating it as "not personalised" puts the plain
  // photo back with nothing left to trigger a correction.
  function designFor(key) {
    var s = window.SLIDECART_STATE && window.SLIDECART_STATE();
    var items = s && s.cart && s.cart.items;
    if (!items) return undefined;
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === key) {
        var p = items[i].properties;
        return (p && p._customization_image) || null;
      }
    }
    return undefined;
  }

  function ensure(url) {
    if (ready[url])   return 'ready';
    if (loading[url]) return 'pending';
    if (failed[url])  return 'failed';
    if (cool[url] > Date.now()) return 'pending';   // between retries: keep loading up

    var probe = new Image();
    probe.src = url;
    if (probe.complete && probe.naturalWidth > 0) { ready[url] = true; return 'ready'; }

    loading[url] = probe;
    if (!since[url]) since[url] = Date.now();

    var loaded = false, waited = false, settled = false;

    function settle(ok, giveUp) {
      if (settled) return;
      settled = true;
      delete loading[url];
      if (ok) ready[url] = true;
      else {
        tries[url] = (tries[url] || 0) + 1;
        if (giveUp || tries[url] >= RETRIES) failed[url] = true;
        else { cool[url] = Date.now() + RETRY_MS; setTimeout(scan, RETRY_MS + 50); }
      }
      scan();
    }

    probe.onload  = function () { loaded = true; if (waited) settle(true); };
    probe.onerror = function () { settle(false); };
    setTimeout(function () { waited = true; if (loaded) settle(true); },
               Math.max(0, MIN_LOADING_MS - (Date.now() - since[url])));
    setTimeout(function () { settle(loaded, true); }, MAX_LOADING_MS);
    return 'pending';
  }

  function veil(anchor, on) {
    var has = anchor.classList.contains('is-loading');
    if (on && !has) anchor.classList.add('is-loading');
    else if (!on && has) anchor.classList.remove('is-loading');
  }

  function scan() {
    if (!root) return;
    var lines = root.querySelectorAll('.item[data-line-item-key]');

    for (var i = 0; i < lines.length; i++) {
      var line   = lines[i];
      var anchor = line.querySelector('.item-image-anchor');
      var img    = anchor && anchor.querySelector('img');
      if (!img) continue;

      var key     = line.getAttribute('data-line-item-key');
      var variant = line.getAttribute('data-variant-id') || '';
      var shown   = img.getAttribute('src') || '';

      // Remember the standard thumbnail while it is still in the node.
      if (variant && isStock(shown) && !stock[variant]) stock[variant] = shown;

      if (img.tibKey !== key) {
        // Slide Cart handed this <img> to another line; it still holds the old
        // design. Put the variant's standard photo back (a recycled node always
        // has the same variant_id, so tibBase is a valid fallback) and keep the
        // loading state up rather than flashing a plain photo as if it were final.
        if (img.tibApplied) {
          img.setAttribute('src', stock[variant] || img.tibBase || BLANK);
          veil(anchor, true);
        }
        img.tibKey = key; img.tibBase = null; img.tibApplied = null;
      }

      var url = designFor(key);
      if (url === undefined) continue;   // state can't tell us — leave the node alone

      var state = url ? ensure(url) : 'none';

      // Plain line, or a design we've given up on: hand the node back to Slide Cart.
      if (state === 'none' || state === 'failed') {
        if (img.tibApplied) {
          if (img.tibBase) img.setAttribute('src', img.tibBase);
          img.tibApplied = null;
        }
        veil(anchor, false);
        continue;
      }

      var current = img.getAttribute('src') || '';
      if (current !== img.tibApplied && isStock(current)) img.tibBase = current;

      if (state === 'ready') {
        if (current !== url) img.setAttribute('src', url);
        img.tibApplied = url;
        veil(anchor, false);
      } else {
        veil(anchor, true);
      }
    }
  }

  function start(el) {
    root = el;

    // Reset failed attempts when the drawer is opened, so a design that failed
    // on a bad connection isn't stuck on the standard photo until a page reload.
    var overlay = root.querySelector('.slidecarthq-overlay');
    if (overlay) {
      new MutationObserver(function () {
        if (overlay.classList.contains('open')) {
          failed = {}; tries = {}; cool = {}; since = {};
          scan();
        }
      }).observe(overlay, { attributes: true, attributeFilter: ['class'] });
    }

    // src only — never class — so our own veil writes can't feed the observer.
    new MutationObserver(scan).observe(root, {
      childList: true, subtree: true, attributeFilter: ['src']
    });
    scan();
  }

  function boot() {
    var el = document.getElementById('slidecarthq');
    if (el) return start(el);
    var waiter = new MutationObserver(function () {
      var e = document.getElementById('slidecarthq');
      if (e) { waiter.disconnect(); start(e); }
    });
    waiter.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { waiter.disconnect(); }, 60000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();